export default __webpack_public_path__ + "static/media/christmas3.e0782ffe.png";